import { createGlobalStyle } from "styled-components";
import bgImg from "./img/bg.jpg";

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    line-height: 1.7;
    -webkit-font-smoothing: antialiased;
  }
  body {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "hiragino kaku gothic pro",meiryo,"ms pgothic",sans-serif;
    font-size: 16px;
    color: #3f261f;
    line-height: 1.7;
    &:before {
      content: "";
      z-index: -1;
      background: #f6e9c9 url(${bgImg}) repeat;
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
    }
  }
  body, html {
    height: 100%;
  }
  svg, img {
    vertical-align: top;
  }
  #root {
    height: 100%;
  }
  a {
    color: #3f261f;
  }
`;

export default GlobalStyle;
